import React from 'react';

const ProductProvider = React.createContext<[any, any]>([{}, {}]);

export default ProductProvider;